import React, { ReactNode } from 'react'

interface InactiveContextProps {
  lastClickTime: number
}

const InactiveContext = React.createContext<InactiveContextProps | undefined>(undefined)

export function IdleProvider ({ children }: { children: ReactNode }) {
  const [lastClickTime, setLastClickTime] = React.useState<number>(Date.now())

  React.useEffect(() => {
    const handleClick = () => {
      setLastClickTime(Date.now())
    }

    window.addEventListener('click', handleClick)

    return () => {
      window.removeEventListener('click', handleClick)
    }
  }, [])

  return (
    <InactiveContext.Provider value={{ lastClickTime }}>
      {children}
    </InactiveContext.Provider>
  )
}

export function useInactiveContext () {
  const context = React.useContext(InactiveContext)
  if (!context) {
    throw new Error('useInactiveContext must be used within a IdleProvider')
  }
  return context
}
